import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import Footer from '../../components/footer/Footer';
import Instagram from '../../components/Instagram/Instagram';
import Events from '../../api/event'
import Logo from '../../images/logo.png'


const EventSinglePage = (props) => {
    const { slug } = useParams()

    const eventDetails = Events.find(item => item.slug === slug)

    return (
        <Fragment>
            <Navbar hclass={'header-style-1'} Logo={Logo} btnClass={'theme-btn-s1'} />
            <PageTitle pageTitle={eventDetails.eTitle} pagesub={'Event'} />
            <section className="event-single-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-md-8">
                            <div className="img-holder">
                                <img
                                    src={eventDetails.eImg}
                                    alt=""
                                    style={{
                                        width: "100%",        // or any fixed value like "650px"
                                        height: "200%",       // or "687px"
                                        objectFit: "cover",   // maintains aspect ratio and fills container
                                        borderRadius: "10px", // optional
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col col-md-4">
                            <div className="event-info">
                                <h3>Event info</h3>
                                <ul>
                                    <li>
                                        <i className="fi flaticon-alarm"></i>
                                        <h5>Start time</h5>
                                        <p>{eventDetails.startTime}</p>
                                    </li>
                                    <li>
                                        <i className="fi flaticon-guarantee"></i>
                                        <h5>End Time</h5>
                                        <p>{eventDetails.endTime}</p>
                                    </li>
                                    <li>
                                        <i className="fi flaticon-down-arrow-3"></i>
                                        <h5>Address</h5>
                                        <p>{eventDetails.address}</p>
                                    </li>
                                    <li>
                                        <i className="fi flaticon-like"></i>
                                        <h5>Organization</h5>
                                        <p>{eventDetails.organization}</p>
                                    </li>
                                    <li>
                                        <i className="fi flaticon-envelope"></i>
                                        <h5>Contact</h5>
                                        <p>{eventDetails.contact}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-xs-12">
                            <div className="event-text">
                                <h2>{eventDetails.eTitle}</h2>
                                <p>{eventDetails.dec}</p>
                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        justifyContent: "center",
                                        gap: "10px",
                                        marginTop: "20px",
                                    }}
                                >
                                    {eventDetails.eventImages
                                        .filter(Boolean) // only include defined images
                                        .slice(0, 6)
                                        .map((imgSrc, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    flex: `1 1 calc(${100 / eventDetails.imagesPerRow}% - 10px)`, // up to 6 per row
                                                    maxWidth: `${100 / eventDetails.imagesPerRow}%`,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <img
                                                    src={imgSrc}
                                                    alt={`event-image-${index}`}
                                                    style={{
                                                        width: "100%",
                                                        height: "auto",
                                                        objectFit: "cover",
                                                        borderRadius: "10px",
                                                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                                        transition: "transform 0.3s ease",
                                                    }}
                                                    onMouseOver={(e) =>
                                                        (e.currentTarget.style.transform = "scale(1.05)")
                                                    }
                                                    onMouseOut={(e) =>
                                                        (e.currentTarget.style.transform = "scale(1)")
                                                    }
                                                />
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Instagram />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default EventSinglePage;
